import { z } from 'zod';

const WorkflowStepFile = z.object({
  id: z.string(),
  fileName: z.string(),
  downloadToken: z.string().nullable(),
  mimetype: z.string(),
  virusFree: z.boolean(),
});

const WorkflowStepComment = z.object({ value: z.string() });

const WorkflowStep = z.object({
  title: z.string(),
  files: z.array(WorkflowStepFile).optional(),
  comments: z.array(WorkflowStepComment).optional(),
  triggeredAt: z.string().nullable().optional(),
  triggeredBy: z.string().nullable().optional(),
  isTriggered: z.boolean(),
});

const WorkflowVisualizationData = z.object({
  steps: z.array(WorkflowStep),
});

export type WorkflowStepFile = z.infer<typeof WorkflowStepFile>;
export type WorkflowStep = z.infer<typeof WorkflowStep>;
export type WorkflowVisualizationData = z.infer<
  typeof WorkflowVisualizationData
>;
export type WorkflowStepComment = z.infer<typeof WorkflowStepComment>;

export function isWorkflowVisualizationData(
  data: unknown
): data is WorkflowVisualizationData {
  return WorkflowVisualizationData.safeParse(data).success;
}
